const Header = () => {
  return (
    <div className="header">
      <div>
        <img
          src="http://www.pngall.com/wp-content/uploads/2016/05/Trollface.png"
          alt="Problem?"
          className="header-img"
        />
        <div className="heading">Meme Generator</div>
      </div>
    </div>
  );
};

export default Header;
